import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-plan-benefits',
  templateUrl: './plan-benefits.component.html',
  styleUrls: ['./plan-benefits.component.scss']
})
export class PlanBenefitsComponent {
  @Input() planBenefits: any[] = [];
  @Input() ancillaryCodes: string = '';
}